import React, { useState, useEffect } from 'react';
import api from '../api';

export default function VerifyEmail({ user, onVerified, onResent }) {
  const [status, setStatus] = useState('pending'); // pending | verifying | verified | error
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);
  const [token, setToken] = useState('');

  // Auto-verify if token is in URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (t) { setToken(t); verifyToken(t); }
  }, []); // eslint-disable-line

  const verifyToken = async (t) => {
    setStatus('verifying');
    try {
      const data = await api.post('/auth/verify-email', { token: t }).then(r => r.data);
      localStorage.setItem('hrtrack_token', data.token);
      localStorage.setItem('hrtrack_user', JSON.stringify(data.user));
      setStatus('verified');
      setTimeout(() => onVerified(data), 1500);
    } catch (err) {
      setStatus('error');
    }
  };

  const handleManualVerify = (e) => {
    e.preventDefault();
    if (token) verifyToken(token);
  };

  const resend = async () => {
    setResending(true);
    try {
      await api.post('/auth/resend-verification').then(r => r.data);
      setResent(true);
      if (onResent) onResent();
    } catch {}
    setResending(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '40px 36px', width: 420, boxShadow: '0 20px 60px rgba(0,0,0,.3)', textAlign: 'center' }}>
        <div style={{ fontSize: '1.8rem', fontWeight: 800, color: '#1e1b4b', marginBottom: 24 }}>HR<span style={{ color: '#4f46e5' }}>Track</span></div>

        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>⏳</div>
            <h2 style={{ color: '#1e1b4b', marginBottom: 8 }}>Verifying…</h2>
          </>
        )}

        {status === 'verified' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>✅</div>
            <h2 style={{ color: '#1e1b4b', marginBottom: 8 }}>Email verified!</h2>
            <p style={{ color: '#64748b' }}>Taking you to your workspace…</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>❌</div>
            <h2 style={{ color: '#1e1b4b', marginBottom: 8 }}>Link expired or invalid</h2>
            <p style={{ color: '#64748b', marginBottom: 20 }}>This verification link has expired or already been used.</p>
            <button onClick={resend} disabled={resending || resent} className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>
              {resent ? 'Email sent!' : resending ? 'Sending…' : 'Resend verification email'}
            </button>
          </>
        )}

        {status === 'pending' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>📧</div>
            <h2 style={{ color: '#1e1b4b', marginBottom: 8 }}>Check your email</h2>
            <p style={{ color: '#64748b', marginBottom: 20 }}>
              We sent a verification link to <strong>{user?.email || 'your email'}</strong>. Click the link to activate your account.
            </p>

            <form onSubmit={handleManualVerify} style={{ marginBottom: 16 }}>
              <div className="form-group" style={{ textAlign: 'left' }}>
                <label>Or paste the verification token here</label>
                <input value={token} onChange={e => setToken(e.target.value)} placeholder="Paste token from email" />
              </div>
              <button type="submit" disabled={!token} className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>Verify</button>
            </form>

            <button onClick={resend} disabled={resending || resent} style={{ background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontSize: '0.875rem' }}>
              {resent ? 'Sent! Check your inbox.' : resending ? 'Sending…' : "Didn't receive it? Resend"}
            </button>
            <div style={{ marginTop: 20, borderTop: '1px solid #f1f5f9', paddingTop: 16 }}>
              <button onClick={() => { localStorage.removeItem('hrtrack_token'); localStorage.removeItem('hrtrack_user'); window.location.reload(); }}
                style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: '0.8rem' }}>
                ← Sign in with a different account
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
